import React from 'react'

const SectionContext = React.createContext({
    currentSection: 0,
    chooseSection: () => { }
});


export default SectionContext